import { api } from "../../../../api/Middleware";
import {
  CRM_DASHBOARD_SUMMARY_URL,
  CRM_DASHBOARD_FUNNEL_URL,
  CRM_DASHBOARD_BY_PERIOD_URL,
  CRM_DASHBOARD_BY_OWNER_URL,
  CRM_DASHBOARD_LOSS_REASONS_URL,
  CRM_DASHBOARD_ACTIVITIES_URL,
} from "../../../../api/Urls";

export const getDashboardSummary = async (pipelineId, period = 30) => {
  const params = { period };
  if (pipelineId) params.pipeline = pipelineId;
  const response = await api.get(CRM_DASHBOARD_SUMMARY_URL, { params });
  return response.data;
};

export const getDashboardFunnel = async (pipelineId) => {
  const response = await api.get(CRM_DASHBOARD_FUNNEL_URL, {
    params: { pipeline: pipelineId },
  });
  return response.data;
};

export const getDashboardByPeriod = async (pipelineId, period = 30) => {
  const params = { period };
  if (pipelineId) params.pipeline = pipelineId;
  const response = await api.get(CRM_DASHBOARD_BY_PERIOD_URL, { params });
  return response.data;
};

export const getDashboardByOwner = async (pipelineId, period = 30) => {
  const params = { period };
  if (pipelineId) params.pipeline = pipelineId;
  const response = await api.get(CRM_DASHBOARD_BY_OWNER_URL, { params });
  return response.data;
};

export const getDashboardLossReasons = async (pipelineId, period = 30) => {
  const params = { period };
  if (pipelineId) params.pipeline = pipelineId;
  const response = await api.get(CRM_DASHBOARD_LOSS_REASONS_URL, { params });
  return response.data;
};

export const getDashboardActivities = async (pipelineId, period = 30) => {
  const params = { period };
  if (pipelineId) params.pipeline = pipelineId;
  const response = await api.get(CRM_DASHBOARD_ACTIVITIES_URL, { params });
  return response.data;
};
